<template>
    <transition name="slide-left">
        <div class="info-panel" v-if="panelInfo" :class="{ open: showContent }">
            <div
                :class="{ section: panelInfo.type == 'section' }"
                class="title-bar"
            >
                <div class="background"></div>
                <h2>{{ panelInfo.title }}</h2>
                <img
                    v-if="awardPath"
                    :src="awardPath"
                    alt="Award"
                    class="award"
                />
                <a
                    v-else-if="panelInfo.type == 'product'"
                    @click.prevent="toggleStats"
                    :class="{ 'close-btn': showClose }"
                    >Info</a
                >
            </div>
            <div class="content" v-show="showContent">
                <transition name="slide-left" @before-enter="changeHotspot">
                    <hotspot-content
                        :content="panelInfo.panel.hotspots"
                        :current="currentShownHotspot"
                        v-show="mode == 'hotspot'"
                    />
                </transition>
                <transition
                    name="slide-left"
                    @after-enter="factsIn = true"
                    @leave="factsIn = false"
                >
                    <product-facts
                        :facts="panelInfo.panel.facts"
                        :video="videoID"
                        :video-thumb="videoThumb"
                        :on-stage="factsIn"
                        v-show="mode == 'facts'"
                    />
                </transition>
                <transition name="slide-left">
                    <product-stats
                        :stats="panelInfo.panel.stats"
                        :show="showStats"
                        v-show="showStats"
                    />
                </transition>
            </div>
        </div>
    </transition>
</template>

<script>
import ProductFacts from './product-facts';
import ProductStats from './product-stats';
import HotspotContent from './hotspot-content';
import { mapState } from 'vuex';
import { isMobileOnly } from 'mobile-device-detect';

export default {
    props: ['panelInfo'],
    components: { ProductFacts, ProductStats, HotspotContent },
    data() {
        return {
            mode: isMobileOnly ? 'mobile' : 'facts',
            currentShownHotspot: null,
            factsIn: false
        };
    },
    computed: {
        ...mapState(['currentHotspot']),
        isPortraitMode() {
            return isMobileOnly || window.innerWidth < 1024;
        },
        videoID() {
            return this.panelInfo.panel.video !== undefined
                ? this.panelInfo.panel.video
                : '';
        },
        videoThumb() {
            return this.panelInfo.panel.videoThumb !== undefined
                ? this.panelInfo.panel.videoThumb
                : '';
        },
        awardPath() {
            return this.panelInfo.panel.award !== undefined
                ? `images/awards/${this.panelInfo.panel.award}`
                : '';
        },
        showClose() {
            return this.isPortraitMode
                ? this.mode == 'facts'
                : this.mode == 'stats';
        },
        showStats() {
            return this.isPortraitMode
                ? this.mode == 'facts'
                : this.mode == 'stats';
        },
        showContent() {
            return this.isPortraitMode ? this.mode !== 'mobile' : true;
        }
    },
    methods: {
        toggleStats() {
            const offVal = this.isPortraitMode ? 'mobile' : 'stats';
            this.delayMode(this.mode == 'facts' ? offVal : 'facts');
        },

        delayMode(newMode) {
            this.mode = '';

            setTimeout(() => {
                this.mode = newMode;
            }, 500);
        },

        changeHotspot() {
            this.currentShownHotspot = this.currentHotspot;
        }
    },
    watch: {
        currentHotspot() {
            if (this.currentHotspot) {
                this.delayMode('hotspot');
            } else {
                this.delayMode(this.isPortraitMode ? 'mobile' : 'facts');
            }
        },
        panelInfo() {
            this.factsIn = true;
            this.mode = this.isPortraitMode ? 'mobile' : 'facts';
        }
    }
};
</script>

<style lang="scss">
.award {
    position: absolute;
    z-index: 10;
    max-height: 80%;
    right: 30px;
}
</style>
